import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col, Button, Card, Offcanvas } from "react-bootstrap";
import Jello from "react-reveal/Jello";
import { useHistory } from "react-router-dom";
import Zoom from "react-reveal/Zoom";
import VerificaToken from "../../components/VerificaToken";

function Incarichi() {
  const { user, setUser } = VerificaToken();
  let history = useHistory();
  const [incarichi, setIncarichi] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [valore, setValore] = useState(0);

  useEffect(() => {
    if (user.tipo === "Amministratore") {
      axios
        .get(
          `https://website-8bit-motors.herokuapp.com/incarichi/ListaCompletaIncarichi`,
          {
            headers: {
              accessToken: localStorage.getItem("accessToken"),
            },
          }
        )
        .then((response) => {
          setIncarichi(response.data);
        });
    } else if (
      user.tipo === "Autista" ||
      user.tipo === "Addetto alla Consegna"
    ) {
      axios
        .get(
          `https://website-8bit-motors.herokuapp.com/incarichi/ListaIncarichi/${user.id}`,
          {
            headers: {
              accessToken: localStorage.getItem("accessToken"),
            },
          }
        )
        .then((response) => {
          setIncarichi(response.data);
        });
    } else {
      history.push("/modificaNonAutorizzata");
    }
  }, []);

  const consegnato = (idPrenotazione) => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/incarichi/consegnato/${idPrenotazione}`
      )
      .then(() => {
        axios
          .put(
            `https://website-8bit-motors.herokuapp.com/prenotazioni/consegnato/${idPrenotazione}`
          )
          .then(() => {
            history.go(0);
          });
      });
  };

  const ritira = (idPrenotazione) => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/incarichi/ritira/${idPrenotazione}`
      )
      .then(() => {
        axios
          .put(
            `https://website-8bit-motors.herokuapp.com/prenotazioni/ritira/${idPrenotazione}`
          )
          .then(() => {
            history.go(0);
          });
      });
  };
  const restituisci = (idPrenotazione, modello) => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/incarichi/restituisci/${idPrenotazione}`
      )
      .then(() => {
        axios
          .put(
            `https://website-8bit-motors.herokuapp.com/prenotazioni/restituisci/${idPrenotazione}`
          )
          .then(() => {
            axios
              .post(
                `https://website-8bit-motors.herokuapp.com/veicoli/${modello}/confermaRestituzione`
              )
              .then(() => {
                history.go(0);
              });
          });
      });
  };
  const elimina = (idPrenotazione, modello) => {
    axios
      .delete(
        `https://website-8bit-motors.herokuapp.com/incarichi/elimina/${idPrenotazione}`
      )
      .then(() => {
        axios
          .delete(
            `https://website-8bit-motors.herokuapp.com/prenotazioni/elimina/${idPrenotazione}`
          )
          .then(() => {
            axios
              .post(
                `https://website-8bit-motors.herokuapp.com/veicoli/${modello}/confermaRestituzione`
              )
              .then(() => {
                history.go(0);
              });
          });
      });
  };

  const eliminaAmm = (idPrenotazione) => {
    axios
      .delete(
        `https://website-8bit-motors.herokuapp.com/incarichi/elimina/${idPrenotazione}`
      )
      .then(() => {
        axios
          .delete(
            `https://website-8bit-motors.herokuapp.com/prenotazioni/elimina/${idPrenotazione}`
          )
          .then(() => {
            history.go(0);
          });
      });
  };

  return (
    <Container fluid className="text-center">
      <Jello>
        {/* SEZIONE BANNER */}
        <Container
          fluid
          className="head-banner text-white text-center"
          id="banner_accesso"
        >
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>
      </Jello>

      <h2 className="mt-2 mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-bag-plus"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M8 7.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0v-1.5H6a.5.5 0 0 1 0-1h1.5V8a.5.5 0 0 1 .5-.5z"
          />
          <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z" />
        </svg>
        Incarichi
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-bag-plus"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M8 7.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0v-1.5H6a.5.5 0 0 1 0-1h1.5V8a.5.5 0 0 1 .5-.5z"
          />
          <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z" />
        </svg>
      </h2>

      <Zoom>
        <Container Fluid>
          <Row>
            {incarichi.map((value, key) => {
              return (
                <>
                  <Col className="col-lg-4">
                    <Card key={key} className="mt-2" style={{ width: "18rem" }}>
                      <Card.Img
                        variant="top"
                        src={`https://website-8bit-motors.herokuapp.com/static/${value.modello}.jpg`}
                      />
                      <Card.Body>
                        <Card.Title>{value.modello}</Card.Title>
                        <Card.Text>
                          <h5>Veicolo Consegnato:</h5>
                          <p>{value.segnala_consegna}</p>
                          <h5>Corsa Iniziata:</h5>
                          <p>{value.inizio_corsa}</p>
                          <h5>Veicolo Restituito:</h5>
                          <p>{value.fine_corsa}</p>
                        </Card.Text>
                        {value.segnala_consegna === "si" ? (
                          <>
                            {value.inizio_corsa ===
                            "si" /* && value.restituito === "no" */ ? (
                              <>
                                {user.tipo !== "Amministratore" && (
                                  <Col>
                                    {" "}
                                    <Button
                                      className="mt-2"
                                      variant="dark"
                                      id="ritiro"
                                      disabled
                                    >
                                      Ritirato
                                    </Button>{" "}
                                  </Col>
                                )}

                                {value.fine_corsa ===
                                "si" /* value.rilasciato === "si" */ ? (
                                  <>
                                    {user.tipo === "Amministratore" && (
                                      <Col>
                                        {" "}
                                        <Button
                                          className="mt-2"
                                          variant="danger"
                                          id="annulla"
                                          onClick={() => {
                                            eliminaAmm(value.id_prenotazione);
                                          }}
                                        >
                                          Elimina Prenotazione
                                        </Button>{" "}
                                      </Col>
                                    )}

                                    {user.tipo === "Autista" && (
                                      <>
                                        <Col>
                                          {" "}
                                          <Button
                                            className="mt-2"
                                            variant="success"
                                            id="restituito"
                                            disabled
                                          >
                                            Restituito
                                          </Button>{" "}
                                        </Col>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {user.tipo === "Autista" && (
                                      <>
                                        <Col>
                                          {" "}
                                          <Button
                                            className="mt-2"
                                            variant="success"
                                            id="restituito"
                                            onClick={() => {
                                              restituisci(
                                                value.id_prenotazione,
                                                value.modello
                                              );
                                            }}
                                          >
                                            Restituito
                                          </Button>{" "}
                                        </Col>
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {user.tipo === "Autista" && (
                                  <>
                                    <Col>
                                      {" "}
                                      <Button
                                        className="mt-2"
                                        variant="dark"
                                        id="ritiro"
                                        onClick={() => {
                                          ritira(value.id_prenotazione);
                                        }}
                                      >
                                        Ritirato
                                      </Button>{" "}
                                    </Col>
                                    <Col>
                                      {" "}
                                      <Button
                                        className="mt-2"
                                        variant="success"
                                        id="restituito"
                                        disabled
                                      >
                                        Restituito
                                      </Button>{" "}
                                    </Col>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {user.tipo === "Amministratore" ? (
                              <Col>
                                {" "}
                                <Button
                                  className="mt-2"
                                  variant="danger"
                                  id="annulla"
                                  onClick={() => {
                                    elimina(
                                      value.id_prenotazione,
                                      value.modello
                                    );
                                  }}
                                >
                                  Elimina Prenotazione
                                </Button>{" "}
                              </Col>
                            ) : (
                              <>
                                <Col>
                                  {" "}
                                  <Button
                                    className="mt-2"
                                    variant="warning"
                                    id="consegnato"
                                    onClick={() => {
                                      consegnato(value.id_prenotazione);
                                    }}
                                  >
                                    Consegnato
                                  </Button>{" "}
                                </Col>
                              </>
                            )}
                          </>
                        )}

                        <Button
                          variant="info"
                          className="mt-2"
                          onClick={() => {
                            setValore(key);
                            setShow(true);
                          }}
                        >
                          Maggiori Informazioni
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Offcanvas show={show} onHide={handleClose}>
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>Prenotazione Veicolo</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <h2>Info Incarico</h2>
                      <br />
                      <h3>Data Noleggio Iniziale:</h3>
                      <p>
                        {incarichi[valore].data_noleggio_iniziale.slice(0, 10)}
                      </p>
                      <h3>Orario Noleggio Iniziale:</h3>
                      <p>{incarichi[valore].orario_noleggio_iniziale}</p>
                      <h3>Data Noleggio Finale:</h3>
                      <p>
                        {incarichi[valore].data_noleggio_finale.slice(0, 10)}
                      </p>
                      <h3>Orario Noleggio Finale:</h3>
                      <p>{incarichi[valore].orario_noleggio_finale}</p>
                      <h3>Luogo di Ritiro:</h3>
                      <p>{incarichi[valore].luogo_rilascio_ritiro}</p>
                      <h3>Modello:</h3>
                      <p>{incarichi[valore].modello}</p>
                      <h3>Destinazione:</h3>
                      <p>{incarichi[valore].destinazione}</p>
                      <h3>Motivazione Ritardo:</h3>
                      <p>{incarichi[valore].motivazione_ritardo}</p>
                    </Offcanvas.Body>
                  </Offcanvas>
                </>
              );
            })}
          </Row>
        </Container>
      </Zoom>

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </Container>
  );
}

export default Incarichi;
